import React, { useEffect, useState, useRef } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import { BiSolidChevronDown } from "react-icons/bi";
import { Popover, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../../store/Slices/CustomerSlice";
import AuthInput from "../../../components/Input/AuthInput";
import { WarningToast } from "../../../utils/ShowToast";
import CustomerSelector from "../../../components/Selector/CustomerSelector";
import InoviceAddItem from "../../../components/InoviceAddItem/InoviceAddItem";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { InvoiceColumns } from "../../../assets/Columns/InvocieColumns";
import { fetchSupplierInvoice } from "../../../store/Slices/SupplierInvoiceSlice";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import { SupplierInvoiceColumns } from "../../../assets/Columns/SupplierInvoiceColumns";
import AddRMStockModal from "../../../components/Modals/AddRMStockModal";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";

const SupplierCreateInvoice = () => {
  const [SearchText, setSearchText] = useState("");
  const [OpenAddStockModal, setOpenAddStockModal] = useState(false);

  const dispatch = useDispatch();
  const SupplierInvoices = useSelector((state) => state.SupplierInvoices);

  useEffect(() => {
    dispatch(fetchSupplierInvoice());
  }, [dispatch]);
  return (
    <BodyWrapper>
      <Header
        title="Stock Statistics"
        desc="Overview of your stocks management"
      >
        <CustomBtn
          title={"Add Stock"}
          onClick={() => {
            setOpenAddStockModal(true);
          }}
        />
      </Header>

      <div className="w-full mt-10 flex justify-center items-center">
        {SupplierInvoices.loading ? (
          <div className="flex flex-1 justify-center items-center">
            <FetchingLoading />
          </div>
        ) : (
          <SearchableTable
            SearchPlaceholder={"Search Product Name..."}
            SearchText={SearchText}
            setSearchText={setSearchText}
            CurrentData={SupplierInvoices.data}
            Columns={SupplierInvoiceColumns}
          />
        )}
      </div>
      {OpenAddStockModal && (
        <AddRMStockModal
          Open={OpenAddStockModal}
          setOpen={setOpenAddStockModal}
        />
      )}
    </BodyWrapper>
  );
};

export default SupplierCreateInvoice;
